<!--发布课程管理-->
<template>
  <div>
    <el-form ref="registerRef" :model="createParam" :rules="rules" label-width="150px">
      <el-row>
        <el-col :span="12">
          <el-form-item label="版本:" prop="userPhone">
            <el-select placeholder="请选择版本" style="width: 270px" v-model="createParam.storeLessonCardTemplateId"
              :disabled="childInfo && childInfo.id ? true : false" @change="changeLessonIdX">
              <el-option v-for="item in [
                { label: 'A', value: 2 },
                { label: 'B', value: 1 },
              ]" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="业务类型:" prop="optionsLessonValue">
            <el-select v-model="createParam.optionsLessonValue" placeholder="请选择业务类型" @change="changeLessonTemplate"
              :disabled="childInfo && childInfo.id ? true : false" style="width: 270px">
              <el-option v-for="item in storeLessons" :key="item.storeLessonId" :label="item.name"
                :value="item.storeLessonId">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="卡名称:" prop="name">
            <el-input style="width: 270px" v-model="createParam.name" :disabled="childInfo && childInfo.id ? true : false"
              placeholder="输入卡名称"></el-input>
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item label="价值(元):" prop="valueMoney">
            <el-input-number v-model="createParam.valueMoney" :disabled="childInfo && childInfo.id ? true : false"
              style="width: 270px" :min="0"></el-input-number>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="卡描述:">
            <el-input style="width: 270px" v-model="createParam.descripe"
              :disabled="childInfo && childInfo.id ? true : false" placeholder="输入卡描述"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="卡使用类型:" prop="useType">
            <el-select v-model="createParam.useType" placeholder="请选择卡使用类型"
              :disabled="childInfo && childInfo.id ? true : false" style="width: 270px">
              <el-option v-for="item in cardUseTypeList" :key="item.v" :label="item.des" :value="item.v">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="计费类型:" prop="consumeType">
            <el-select @change="changeValue" v-model="createParam.consumeType" placeholder="请选择" style="width: 270px"
              :disabled="childInfo && childInfo.id ? true : false">
              <el-option v-for="item in [
                {
                  value: 0,
                  label: '次卡',
                },
                {
                  value: 1,
                  label: '时效卡',
                },
              ]" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12" v-if="createParam.consumeType == 0">
          <el-form-item label="正价课时:" prop="totalClassCount">
            <el-input-number v-model="createParam.totalClassCount" :disabled="childInfo && childInfo.id ? true : false"
              style="width: 270px" :min="0"></el-input-number>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12" v-if="createParam.consumeType == 0">
          <el-form-item label="赠送课时:" prop="giveClassCount">
            <el-input-number v-model="createParam.giveClassCount" :disabled="childInfo && childInfo.id ? true : false"
              style="width: 270px" :min="0"></el-input-number>
          </el-form-item>
        </el-col>
        <el-col :span="12" v-if="createParam.consumeType == 0">
          <el-form-item label="卡有效时长(天):" prop="validDays">
            <el-input-number v-model="createParam.validDays" :disabled="childInfo && childInfo.id ? true : false"
              style="width: 270px" :min="0"></el-input-number>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row v-if="createParam.consumeType == 1">
        <el-col :span="12">
          <el-form-item label="时间:" prop="value1">
            <el-date-picker v-model="createParam.value1" value-format="yyyy-MM-dd" type="daterange" range-separator="-"
              start-placeholder="开始日期" end-placeholder="结束日期" style="width: 270px"
              :disabled="childInfo && childInfo.id ? true : false">
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="频率:" prop="">
            <el-input-number v-model="createParam.frequency" style="width: 270px" :min="0"
              :disabled="childInfo && childInfo.id ? true : false"></el-input-number>
            (课/周)
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="状态:" prop="optionsUseValue">
            <el-select v-model="createParam.optionsUseValue" placeholder="请选择" style="width: 270px">
              <el-option v-for="item in [
                {
                  value: 0,
                  label: '启用',
                },
                {
                  value: 1,
                  label: '禁用',
                },
              ]" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12"></el-col>
      </el-row>
      <el-form-item label="备注:">
        <el-input type="textarea" v-model="createParam.remark" :autosize="{ minRows: 4 }" placeholder="请输入内容"
          style="width: 740px"></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer-1">
      <el-button @click="handleCancel">取消</el-button>
      <el-button type="primary" @click="handleCreate('registerRef')">保存</el-button>
    </div>
    <worker-word ref="workerWord" :key="refreshWord" :word-type="wordType" :t-data="tData" :show="showWordDlg"
      @onWorkerWord="handleWord"></worker-word>

  </div>
</template>

<style></style>

<script>
import { qlLessonTemplate } from "@/api/StoreLesson";
import globaldata from "../../../utils/globaldata";
import enumsUtil, { ECardUseType } from "../../../utils/enumsUtil";
import commonUtils from "../../../utils/commonUtils";
import { getCardSubTypeList, newLessonVipCard } from "../../../api/StoreLessonCard";
import WorkerWord from "@/components/WorkerWord/WorkerWord";
import {
  createExpCard,
  forbitLessonCard,
  useLessonCard,
} from "@/api/StoreLessonCard";
import messageUtils from "@/utils/messageUtils";

export default {
  name: "NewStoreLessonCardInfo",
  props: {
    isExp: Number, //是否是体验卡
    // storeLessons: Array,
    childInfo: Object
  },
  components: { WorkerWord },
  data() {
    return {
      wordType: 0,
      tData: {
        adminWord: ''
      },
      refreshWord: new Date().getTime(),
      storeLessons: [],
      createParam: {},
      showWordDlg: false,
      rules: {
        name: [{ required: true, message: "请输入卡名称", trigger: "blur" }],
        descripe: [
          { required: true, message: "请输入卡描述", trigger: "blur" },
        ],
        storeLessonCardTemplateId: [
          { required: true, message: "请选择业务类型", trigger: "blur" },
        ],
        useType: [
          { required: true, message: "请选择使用类型", trigger: "blur" },
        ],
        consumeType: [
          { required: true, message: "请选择计费类型", trigger: "blur" },
        ],
        totalClassCount: [
          { required: true, message: "请输入正价课时", trigger: "blur" },
        ],
        valueMoney: [
          { required: true, message: "请输入价格", trigger: "blur" },
        ],
        optionsUseValue: [
          { required: true, message: "请选择启用状态", trigger: "blur" },
        ],
        optionsLessonValue: [
          { required: true, message: "请选择业务类型", trigger: "blur" },
        ],
        validDays: [
          { required: true, message: "请选择卡有效时长", trigger: "blur" },
        ],
        
      },
      cardUseTypeList: ECardUseType(),
      subCardTypes: [],
    };
  },
  created() {
    this.initData();
  },

  mounted() { },
  methods: {
    handleWord(wordType, tData) {
      console.log(wordType, tData, '===============')
      if (this.childInfo && this.childInfo.id) {
        let params = {
          cardId: this.childInfo.id,
          storeFrontId: globaldata.getAdminStore().storeFrontId,
          adminId: globaldata.getAdminStore().id,
          adminWord: tData.adminWord,
          storeLessonId: this.createParam.optionsLessonValue
        }
        if (this.createParam.optionsUseValue == 0) {
          this.handleUse(params)
        } else {
          this.handleForbit(params)
        }
      } else {
        this.createParam.startTime = this.createParam.value1[0]
        this.createParam.endTime = this.createParam.value1[1]
        // delete this.createParam.value1
        let param = {
          ...this.createParam,
          storeFrontId: globaldata.getAdminStore().storeFrontId,
          adminWord: tData.adminWord,
          statu: this.createParam.optionsUseValue,
          experience: this.isExp,
          storeLessonId: this.createParam.optionsLessonValue
        }
        newLessonVipCard(param).then((res) => {
          if (res.code == 20000) {
            this.$emit("onBtnCreate");
          }
        })
      }

    },
    changeLessonIdX(e) {
      // console.log(e,'===============')
      // return
      this.createParam.optionsLessonValue = ''
      qlLessonTemplate({
        lessonId: e,
        storeFrontId: globaldata.getAdminStore().storeFrontId,
      }).then((res) => {
        if (res.code == 20000) {
          this.storeLessons = res.data
        }
      })
    },
    handleCancel() {
      this.$emit("onBtnCancel");
    },
    handleCreate(registerRef) {
      this.$refs[registerRef].validate((valid) => {
        if (valid) {
          if (this.childInfo && this.childInfo.id) {
            messageUtils.warningMsg(this, '功能正在升级中，敬请期待！');
          } else {
            this.showWordDlg = true
            this.$refs['workerWord'].showDlog = true
            console.log(this.showWordDlg, '===============')

          }
          //   let param = this.createParam;
          //   param.storeFrontId = globaldata.getAdminStore().storeFrontId;
          //   param.createAdminId = globaldata.getAdminStore().id;
          //   createUserChild(param).then((response) => {
          //     messageUtils.successMsg(this, "创建成功");
          //     this.$emit("onBtnCreate");
          //   });
        } else {
          return false;
        }
      });
    },
    //禁用
    handleForbit(param) {
      forbitLessonCard(param).then((response) => {
        let date = response.data;
        if (commonUtils.isObjectNull(date)) {
          return;
        }
        if (response.code == 20000) {
          messageUtils.successMsg(this, response.message);
          this.$emit("onBtnCreate");
        }
      });
    },
    //启用
    handleUse(param) {
      useLessonCard(param).then((response) => {
        let date = response.data;
        if (commonUtils.isObjectNull(date)) {
          return;
        }
        if (response.code == 20000) {
          messageUtils.successMsg(this, response.message);
          this.$emit("onBtnCreate");
        }
      });
    },
    initData() {
      this.createParam = {
        storeLessonCardTemplateId: this.childInfo && this.childInfo.storeLessonCardTemplateId ? this.childInfo.storeLessonCardTemplateId : "",
        name: this.childInfo && this.childInfo.name ? this.childInfo.name : "",
        descripe: "",
        valueMoney: this.childInfo && this.childInfo.valueMoney ? this.childInfo.valueMoney : "",
        validDays: this.childInfo && this.childInfo.validDays ? this.childInfo.validDays : 0,
        optionsLessonValue: this.childInfo && this.childInfo.storeLessonId
          ? this.childInfo.storeLessonId : "",
        consumeType: this.childInfo && this.childInfo.consumeType ? this.childInfo.consumeType : 0,
        useType: this.childInfo && this.childInfo.useType ? this.childInfo.useType : 0,
        value1: this.childInfo && this.childInfo.validTimes && this.childInfo.validTimes.length ? this.childInfo.validTimes : [],
        frequency: "",
        // value1:'',
        totalClassCount: this.childInfo && this.childInfo.totalClassCount ? this.childInfo.totalClassCount : "",
        giveClassCount: this.childInfo && this.childInfo.giveClassCount ? this.childInfo.giveClassCount : "",
        optionsUseValue: this.childInfo && this.childInfo.id ? this.childInfo.statu : "",
        startTime: '',
        endTime: '',
        points: 0,
        createAdminId: globaldata.getAdminStore().id,
        // createAdminName: "",
        remark: this.childInfo && this.childInfo.remark ? this.childInfo.remark : "",
        frequency: this.childInfo && this.childInfo.frequency ? this.childInfo.frequency : 0,
        // options: [
        //   {
        //     value: "0",
        //     label: "按次",
        //   },
        // ],
        // optionsValue: "",
        // optionsLesson: [
        //   {
        //     id: "0",
        //     name: "基础游",
        //   },
        // ],
        // optionsLessonValue: "",
        // optionsUse: [
        //   {
        //     value: 0,
        //     label: "启用",
        //   },
        //   {
        //     value: 1,
        //     label: "禁用",
        //   },
        // ],
        // optionsUseValue: 0,
        // points: 0,
        // useType: 0,
      };
    },
    changeValue(e) {
      if(e == 1){
        this.rules = {
          ...this.rules,
          value1: [
            { required: true, message: "请输入时间", trigger: "blur" }
          ],

        }
      }
      this.createParam.value1 = []
      this.createParam.frequency = ''
      this.createParam.giveClassCount = ''
      this.createParam.totalClassCount = ''
    },
    getstoreLesson(lessonTemplateId) {
      for (let i = 0; i < this.storeLessons.length; ++i) {
        if (this.storeLessons[i].id == lessonTemplateId) {
          return this.storeLessons[i];
        }
      }
    },
    changeLessonTemplate(val) {
      let param = {
        storeFrontId: globaldata.getAdminStore().storeFrontId,
        storeLessonCardTemplateId: val,
      };
      this.subCardTypes = [];
      // this.createParam.cardSubTypeId = "";
      getCardSubTypeList(param).then((response) => {
        let data = response.data;
        if (commonUtils.isObjectNull(data)) {
          return;
        }
        for (let i = 0; i < data.length; ++i) {
          let option = {
            id: data[i].id,
            type: data[i].name,
          };
          this.subCardTypes.push(option);
        }
      });
    },
    getCardInfo(callBack) {
      this.$refs["registerRef"].validate((valid) => {
        if (valid) {
          let storeLessonId = this.getstoreLesson(
            this.createParam.optionsLessonValue
          ).storeLessonId;

          let info = {
            storeFrontId: globaldata.getAdminStore().storeFrontId,
            name: this.createParam.name,
            descripe: this.createParam.descripe,
            storeLessonCardTemplateId: this.createParam.optionsLessonValue,
            storeLessonId: storeLessonId,
            validDays: this.createParam.validDays,
            totalClassCount: this.createParam.totalClassCount,
            giveClassCount: this.createParam.giveClassCount,
            valueMoney: this.createParam.valueMoney,
            createAdminId: globaldata.getAdminStore().id,
            consumeType: this.createParam.optionsValue,
            statu: this.createParam.optionsUseValue,
            points: this.createParam.points,
            experience: this.isExp,
            useType: this.createParam.useType,
            // cardSubTypeId: this.createParam.cardSubTypeId,
          };

          if (callBack) {
            callBack(info);
          }

          return info;
        } else {
          if (callBack) {
            callBack(false);
          }

          return false;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>/deep/ .el-form-item {
  margin-bottom: 20px !important;
}</style>



// WEBPACK FOOTER //
// src/views/store-lesson-card/components/vipCardVT.vue